

import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { LookupItem } from '@/model/LookupItem';

@Component({ inject: ["form"] })
export default class DualListBox extends Vue {

    created() {
        // for validation
        // from https://stackoverflow.com/questions/65410355
        // https://github.com/vuetifyjs/vuetify/blob/master/packages/vuetify/src/components/VInput/VInput.ts
        (this as any).form.register(this);
    }

    // for lazy validation
    didValidate = false;

    resetValidation() {
        this.errorText = "";
        this.errorCssClass = "";
        this.didValidate = false;
    }

    validate(isForce = false): boolean {
        let isValid = true;
        let errorText = "";
        this.rules.forEach(rule => {
            const ruleResult = rule(this.addedList);
            const isOk = (typeof ruleResult === "boolean" && ruleResult);
            if(!isOk) {
                isValid = false;
                if(typeof ruleResult === "string") {
                    errorText += errorText === "" ? ruleResult : ` | ${ruleResult}`;
                }
            }
        });
        this.errorText = errorText;
        this.errorCssClass = isValid ? "" : "has-error";
        this.didValidate = true;
        return isValid;
    }

    @Prop({ required: true })
    idList!: Array<number|string>;

    @Prop({ required: true })
    lookupList!: Array<LookupItem>;

    @Prop({ default: "" })
    addListTitle!: string;

    @Prop({ default: "" })
    removeListTitle!: string;

    @Prop({ default: () => [] })
    rules!: Array<(value:any) => string|boolean>;

    errorCssClass: string = "";

    errorText: string = "";

    selectedIDsToAdd: Array<number> = [];
    selectedIDsToRemove: Array<number> = [];

    get addedList(): Array<LookupItem> {
        return this.lookupList.filter(l => this.idList.indexOf(l.id) !== -1);
    }

    get removedList(): Array<LookupItem> {
        return this.lookupList.filter(l => this.idList.indexOf(l.id) === -1);
    }

    addItems() {
        const selectedIDs = this.selectedIDsToAdd.slice(); // copy
        this.selectedIDsToAdd = []; // unselect
        for(let i = 0; i < selectedIDs.length; i++) {
            this.idList.push(selectedIDs[i]);
        }
        // lazy validation
        if(this.didValidate) this.validate();
    }

    removeItems() {
        const selectedIDs = this.selectedIDsToRemove.slice(); // copy
        this.selectedIDsToRemove = []; // unselect
        for(let i = 0; i < selectedIDs.length; i++) {
            const index = this.idList.indexOf(selectedIDs[i]);
            if (index === -1) continue;
            this.idList.splice(index, 1);
        }
        // lazy validation
        if(this.didValidate) this.validate();
    }
}

